import {useState} from "react";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

function useAxiosInstance() {
    const navigate = useNavigate();
    const [axiosInstance] = useState(() => {
        console.log("API Base Url: " + process.env.REACT_APP_API_BASE_URL)

        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_BASE_URL,
            headers: {
                'Content-Type': 'application/json',
            }
        });

        instance.interceptors.request.use((config) => {
            const token = localStorage.getItem("_MIHEALTHTOKEN");
            if (token) {
                config.headers.Token = token;
            }
            return config;
        });

        instance.interceptors.response.use(
            (response) => {
                const {data} = response;
                if (!data.success) {
                    if (data.message === "Unauthorized!") {
                        localStorage.clear();
                        navigate("/");
                    }
                    Swal.fire(data.message);
                    return Promise.reject(response);
                }
                return data.data;
            },
            (error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        Swal.fire(error.response.data.message);
                        localStorage.clear();
                        navigate("/");
                    }
                } else if (error.request) {
                    Swal.fire("No response received from the server (500)")
                } else {
                    Swal.fire("Error in making the request")
                }
                return Promise.reject(error);
            }
        );
        return instance;
    });

    return axiosInstance;
}

export default useAxiosInstance;